import React, { useState } from 'react'

const QueryForm = ({ setShowQueryForm, product, userDetails }) => {
  const [query, setQuery] = useState('');
  const [selectedQuery, setSelectedQuery] = useState('');

  // Handle form submission (you can replace this with actual logic to send the query)
  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare data to send to backend
    const queryData = {
      query: selectedQuery, // Selected query type
      description: query, // The query description
      user_id: userDetails ? userDetails.id : null,
      order_id: product.orderId,
    };

    // Send data to backend (example using fetch)
    fetch('https://api.dectwincam.com/api/ticket', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(queryData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // On success, show success message and close the form
          alert('Query Submitted Successfully');
          setShowQueryForm(false);
        } else {
          // Handle failure (e.g., show error message)
          alert('Failed to submit query');
        }
      })
      .catch((error) => {
        console.error('Error submitting query:', error);
        alert('There was an error submitting the query');
      });
  };


return (
  <>
    <section className="login-outer w-100">
      <div className="login-inner">
        <h5>Raise Query for Order ID: #00{product ? product.orderId : 'N/A'}</h5>

        <form className='my-4 text-start' onSubmit={handleSubmit}>

          <div className='col-12'>
            <label for="inputStock3">Select Query</label>
            <select className="login-input" name='stock' value={selectedQuery}
                onChange={(e) => setSelectedQuery(e.target.value)} required>
              <option className="login-input" value="" selected disabled>Choose from</option>
              <option className="login-input" value="Delivery Delay">Delivery Delay</option>
              <option className="login-input" value="Less Product Quantity">Less Product Quantity</option>
              <option className="login-input" value="Return Product">Return Product</option>
              <option className="login-input" value="Return Product">Return Status</option>
            </select>
          </div>

          <div className='col-12'>
            <label htmlFor="query">Brief Description</label>
            <textarea
              id="query"
              className="login-input"
              placeholder="Describe your query..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              required
            />
          </div>

          <div className="d-flex">
            <button type="button" className="login-btn" onClick={() => setShowQueryForm(false)}>
              Close Query
            </button>
            <button type="submit" className="login-btn ms-2">
              Submit Query
            </button>
          </div>
        </form>
      </div>
    </section>
  </>
)
}

export default QueryForm
